





import { CommitteeModelInterface } from "@api/models/interfaces/committees/CommitteeModelInterface";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import { getIsCommitteeAllowed } from "@share/common/helpers/ticketSystemHelpers";
import { Vue, Component, Provide } from "vue-property-decorator";

import E404 from "@service/views/errors/e404.vue";
import { EventType } from "@share/common/types/enums/EventType";

@Component({ components: { E404 } })

export default class CommitteesRootView extends Vue {

    @Provide()
    setActiveSectionType(value: EventType) {
        this.activeSectionType = value;
    }

    committee: CommitteeModelInterface | null = null;
    activeSectionType: EventType = EventType.upcoming;

    created() {
        this.$store.dispatch("setPageTitle", this.$t("common.committees"));
    }

    close() {
        this.committee = null;
        this.$router.push({
            name: RouteNamesEnum.committeesList,
            params: {}
        });
    }

    open(committee: CommitteeModelInterface) {

        if(!committee.id) {
            throw new Error("Expected committee id for going to edit one");
        }

        this.committee = committee;

        this.$router.push({
            name: RouteNamesEnum.committeesView,
            params: {
                id: committee.id
            }
        })
        .catch((r) => {r})
    }

    edit(committee: CommitteeModelInterface) {
        if(!committee.id) {
            throw new Error("Expected committee id for going to edit one");
        }

        this.committee = committee;

        this.$router.push({
            name: RouteNamesEnum.committeesEdit,
            params: {
                id: committee.id
            }
        })
        .catch((r) => {r})
    }

    get isCommitteeAllowed() {
        return getIsCommitteeAllowed(this.$store.getters["groupIds"]);
    }
}
